import React from 'react';
import { MainPageLayout } from '../layout/MainPageLayout';
import { FactoryNavigationBar } from '../component/navigation-bar/FactoryNavigationBar';
import { LocalServerDiv2 } from '../component/local-server-new/LocalServerDiv2';

export const LocalServerPage2 = () => (
  <MainPageLayout
    navigationBar={<FactoryNavigationBar />}
    elementCentr={<LocalServerDiv2 />}
  />
);
